import script from "./AlarmList.vue?vue&type=script&setup=true&lang=js"
export * from "./AlarmList.vue?vue&type=script&setup=true&lang=js"

import "./AlarmList.vue?vue&type=style&index=0&id=6401b29b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6401b29b"]])

export default __exports__